import { render, staticRenderFns } from "./QuickNavWidget.vue?vue&type=template&id=6c0b39b2&scoped=true&"
import script from "./QuickNavWidget.vue?vue&type=script&lang=js&"
export * from "./QuickNavWidget.vue?vue&type=script&lang=js&"
import style0 from "./QuickNavWidget.vue?vue&type=style&index=0&id=6c0b39b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b39b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VIcon,VRow})
